import axios from "axios"
import { baseUrlPostGres } from "../constant"
import HandleError from "../HandleError"
import { apiHeader } from "./ApiHeader"
import { FANTASY_POINTS_SUCCESS, FANTASY_POINTS_UPDATED_SUCCESS, IS_LOADING } from "./Type"
import { apiVersion } from "src/utils/apiVersion"

export const GetFantasyPoints = () => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/fantasy_list`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: FANTASY_POINTS_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            console.log("user list error", errors);
        })
}

export const ResetFantasyPoints = () => async (dispatch) => {
    dispatch({
        type: FANTASY_POINTS_SUCCESS,
        payload: {}
    })
}

export const UpdateFantasyPoints = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .put(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/update_fantasygame_points`, data, {
            headers: apiHeader()
        })
        .then((response) => {
            dispatch({
                type: FANTASY_POINTS_UPDATED_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            console.log("user list error", errors);
        })
}

export const ResetUpdateFantasyPoints = () => async (dispatch) => {
    dispatch({
        type: FANTASY_POINTS_UPDATED_SUCCESS,
        payload: {}
    })
}